import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config";

export default function PostRound() {

  const navigate = useNavigate();


  // Pull user info from localStorage (your existing auth method)
  const user_id = localStorage.getItem("userId");
  const email = localStorage.getItem("email");   // ⭐ REQUIRED FOR WEBHOOK EMAIL

const [formData, setFormData] = useState({
  title: "",
  price: "",
  total_cut_value: "",
  yearly_revenue: "",
  clients_count: "",
  suburb: "",
  state: "",
  postcode: "",
  description: "",
  promoCode: "",
});
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    const token = localStorage.getItem("token");

    if (!token) {
      setErrorMessage("Authentication expired. Please log in again.");
      return;
    }

    try {
      const payload = {
        user_id,
        email, // ⭐ passes to webhook so seller gets activation email

        title: formData.title,
        description: formData.description,
        promoCode: formData.promoCode,
        price: formData.price,
        total_cut_value: formData.total_cut_value,
        yearly_revenue: formData.yearly_revenue,
        clients_count: formData.clients_count,
        suburb: formData.suburb,
        state: formData.state,
        postcode: formData.postcode,

        enquiry_only: 1, // Always enquiry-only
        badge: null,
        status: "active",
      };

      const res = await axios.post(
        `${API_BASE_URL}/api/lawn-mowing/rounds/create`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

if (res.data.success) {

 if (res.data.promoApplied) {
    navigate(`/promotion-activation-success?listingId=RND-${res.data.listing_id}`);
} else {
    // Redirect to Stripe Checkout
    window.location.href = res.data.checkout_url;
}

} else {
    setErrorMessage(res.data.error || "Failed to create listing.");
}

    } catch (err) {
      console.error("Round creation error:", err);
      setErrorMessage("Server error creating listing.");
    }
  };

  // -----------------------------
  // UI STYLES – copied exactly from business posting
  // -----------------------------
  const container = {
    maxWidth: "700px",
    margin: "120px auto 20px",
    background: "#fff",
    padding: "25px",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    zIndex: 1,
    position: "relative",
  };

  const header = {
    color: "#2e7d32",
    fontWeight: "bold",
    fontSize: "1.6rem",
    marginBottom: "20px",
  };

  const sectionHeader = {
    background: "#e8f5e9",
    padding: "10px",
    borderRadius: "6px",
    marginTop: "20px",
    fontWeight: "bold",
    color: "#1b5e20",
  };

  const inputStyle = {
    width: "100%",
    padding: "10px",
    marginTop: "8px",
    marginBottom: "12px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "1rem",
  };

  const submitButton = {
    width: "100%",
    padding: "14px",
    background: "#2e7d32",
    color: "#fff",
    border: "none",
    fontSize: "1.2rem",
    fontWeight: "bold",
    borderRadius: "8px",
    marginTop: "25px",
    cursor: "pointer",
  };

  return (
    <div style={container}>
      <div style={header}>Create Lawn Mowing Round Listing</div>

      {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}

      <form onSubmit={handleSubmit}>
        <div style={sectionHeader}>Round Information</div>

        <label>Round Title</label>
        <input name="title" style={inputStyle} value={formData.title} onChange={handleChange} required />

        <label>Sale Price ($)</label>
        <input type="number" name="price" style={inputStyle} value={formData.price} onChange={handleChange} required />

        <label>Total Cut Value ($)</label>
        <input type="number" name="total_cut_value" style={inputStyle} value={formData.total_cut_value} onChange={handleChange} />

        <label>Yearly Revenue ($)</label>
        <input type="number" name="yearly_revenue" style={inputStyle} value={formData.yearly_revenue} onChange={handleChange} required />

        <label>Number of Clients</label>
        <input type="number" name="clients_count" style={inputStyle} value={formData.clients_count} onChange={handleChange} required />

        {/* ⭐ Frequency REMOVED */}

        <label>Suburb</label>
        <input name="suburb" style={inputStyle} value={formData.suburb} onChange={handleChange} required />

        <label>State</label>
        <select name="state" value={formData.state} onChange={handleChange} style={inputStyle} required>
          <option value="">Select State</option>
          <option value="VIC">VIC</option>
          <option value="NSW">NSW</option>
          <option value="QLD">QLD</option>
          <option value="SA">SA</option>
          <option value="WA">WA</option>
          <option value="TAS">TAS</option>
          <option value="NT">NT</option>
          <option value="ACT">ACT</option>
        </select>

        <label>Postcode (optional)</label>
        <input name="postcode" style={inputStyle} value={formData.postcode} onChange={handleChange} />

        <label>Description</label>
        <textarea name="description" rows="4" style={inputStyle} value={formData.description} onChange={handleChange} required />

        <label>Promotion Code (Optional)</label>
<input
  type="text"
  name="promoCode"
  style={inputStyle}
  value={formData.promoCode}
  onChange={handleChange}
  placeholder="Enter promotion code"
/>

        <button type="submit" style={submitButton}>
          Post Round Listing
        </button>
      </form>
    </div>
  );
}
